// services/api/roleApi.js
import axiosInstance from "utils/axiosInstance";

const roleApi = {
  /**
   * Fetches all roles
   * @returns {Promise<Array>} A promise that resolves to an array of role objects
   */
  getRoles: async () => {
    const response = await axiosInstance.get("/roles/getall");
    return response.data || [];
  },

  /**
   * Creates a new role
   * @param {Object} roleData - The role data to create
   * @returns {Promise<Object>} A promise that resolves to the created role object
   */
  createRole: async (roleData) => {
    const response = await axiosInstance.post("/roles/create", roleData);
    return response.data;
  },

  /**
   * Updates an existing role
   * @param {string} roleId - The ID of the role to update
   * @param {Object} roleData - The updated role data
   * @returns {Promise<Object>} A promise that resolves to the updated role object
   */
  updateRole: async (roleId, roleData) => {
    const response = await axiosInstance.put(`/roles/update/${roleId}`, roleData);
    return response.data;
  },

  /**
   * Deletes a role
   * @param {string} roleId - The ID of the role to delete
   * @returns {Promise<Object>} A promise that resolves to the response data
   */
  deleteRole: async (roleId) => {
    const response = await axiosInstance.delete(`/roles/delete/${roleId}`);
    return response.data;
  }
};

export default roleApi;